<template>
  <div class="LineClassEditSeatChart">
    <Header :title="title" :showBack="true"></Header>
    <div class="LineEditContent">
      <!-- 标题 -->
      <div class="LineEditSeatSecondTitle">
        <div>{{ LineClassName }}</div>
        <div class="titleTime">{{ ClassTime }}</div>
      </div>
      <div class="LineEditSeat">
        <!-- 顶部按钮 -->
        <div class="LineSeatTopButtonArea">
          <div class="seatButton" @click="clickEditSeatCount">
            更改座位数
          </div>
          <div class="seatButton" @click="clickEditSeatRefresh">刷新</div>
        </div>
        <!-- 内容 -->
        <div class="LineEditSeatContent">
          <div
            v-for="(i, ind) in LineClassSeatList"
            :key="ind"
            class="LineSeatItem"
            :style="{
              'background-color': i.bgColor,
              border: handlerSelectSeat(i.SeatNo)
                ? '2px solid #f00d30'
                : '2px solid' + i.bgColor,
            }"
            @click="clickSelectSeat(i)"
          >
            <p class="LineSeatItemInd">{{ i.SeatNo }}</p>
            <p>{{ i.SeatStatusName }}</p>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="LineEditSeatFooter">
        <!-- tag  -->
        <div class="LineSeatTag">
          <p v-for="(i, ind) in LineClassSeatTagList" :key="ind">
            {{ i.title }}:
            <span :style="{ color: i.bgColor, 'font-weight': 700 }">
              {{ i.count }}
            </span>
          </p>
        </div>
        <div class="LineEditSeatFooterTotal">
          <p class="LineEditSeatFooterTotalNumber">
            已选择：<span class="number">{{ LineSeatSelectList.length }}</span>
            个座位
          </p>
          <div class="LineEditSeatFooterAll">
            <van-checkbox
              v-model="LineEditSeatAll"
              icon-size="16px"
              shape="square"
              checked-color="#1989fa"
              @click="changeLineEditSeatAll"
            >
              全选
            </van-checkbox>
          </div>
        </div>

        <div class="LineEditSeatFooterButton">
          <div class="footerButton" @click="clickEditSeatStatus(9,'04')">
            设置为留位
          </div>
          <div class="footerButton" @click="clickEditSeatStatus(4,'09')">
            设置为停售
          </div>
          <div class="footerButton" @click="clickEditSeatStatus(0,'49')">
            设置为可售
          </div>
        </div>
      </div>
    </div>

    <!-- 更改座位数量弹窗 -->
    <van-dialog
      v-model="showChangeSeatNumber"
      title="请输入班线座位数量:"
      show-cancel-button
      v-on:confirm="onChangeSeat"
      v-on:cancel="closeChangeDialog"
      :before-close="onChangeSeatBeforeClose"
    >
      <van-stepper v-model="editSeatCount" integer min="1" max="1999" />
    </van-dialog>
  </div>
</template>
<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "修改座位图", //标题
      LineClassName: "", // 线路名称
      ClassTime: "", // 线路时间
      GID: "",
      LineClassSeatList: [], // 线路班次座位列表
      showChangeSeatNumber: false, // 更改座位数弹窗
      oldSeatCount: 0, // 座位数量
      editSeatCount: 0, // 更改座位数量
      LineSeatSelectList: [], // 已选择的座位
      LineSeatSelectListNo: [], // 已选择的座位号
      LineClassSeatTagList: [], // 座位状态统计tag
      LineEditSeatAll: false, // 全选
    };
  },
  computed: {
    handlerSelectSeat() {
      return function (data) {
        let flag = false;
        this.LineSeatSelectListNo.forEach((item) => {
          if (item == data) flag = true;
        });
        return flag;
      };
    },
    // 获取用户数据
    adminInfo() {
      return JSON.parse(window.localStorage.getItem("adminInfo"));
    },
  },
  mounted() {
    // 初始化
    this.InitSeat();
  },
  beforeDestroy() {
    window.localStorage.removeItem("LineEditSeatInfo");
  },
  methods: {
    // 点击全选
    changeLineEditSeatAll() {
      this.LineSeatSelectList = []; // 已选择的座位
      this.LineSeatSelectListNo = []; // 已选择的座位号
      if (this.LineEditSeatAll) {
        this.LineSeatSelectList = this.LineClassSeatList;
        this.LineClassSeatList.forEach((item) => {
          this.LineSeatSelectListNo.push(item.SeatNo);
        });
      }
    },
    // 点击修改座位状态
    clickEditSeatStatus(item,oldStatus) {
      if (
        this.LineSeatSelectListNo.length == 0 ||
        this.LineSeatSelectList.length == 0
      ) {
        this.$toast("请选择座位号");
        return;
      }

      let temp = null;
      switch (item) {
        case 9:
          temp = "留位";
          break;
        case 4:
          temp = "停售";
          break;

        case 0:
          temp = "可售";
          break;
      }
      this.$dialog
        .confirm({
          title: "提醒",
          message: "是否修改座位状态为" + temp + "？",
        })
        .then(() => {
          let params = {
            ClassGID: this.GID,
            SeatNoList: this.LineSeatSelectListNo.join(","),
            OldStatusFlag: oldStatus, // 原座位图标识，支持多种，如：0DF，表示支持0、D、F三种状态
            NewStatusFlag: String(item),
            ModifyGID: this.adminInfo.GID, //操作员GID
            ModifyCode: this.adminInfo.UserCode, //操作员代码
            ModifyName: this.adminInfo.UserName, //操作员名称
            Remark: "", // 备注
          };
          // 处理原座位状态
          // this.LineSeatSelectList.forEach((item) => {
          //   if (!params.OldStatusFlag.includes(item.SeatStatusFlag)) {
          //     params.OldStatusFlag += item.SeatStatusFlag;
          //   }
          // });
          // 请求
          this.$http
            .post(
              this.$api.LineClassSeatStatusChange,
              this.$qs.stringify(params)
            )
            .then((res) => {
              if (res.success) {
                let data = {
                  toastText: "修改座位状态成功",
                };
                this.InitSeat(data);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // console.log("取消");
        });
    },
    // 点击选择座位
    clickSelectSeat(data) {
      if (this.LineSeatSelectList.length == 0) {
        this.LineSeatSelectList.push(data);
      } else {
        let flag = false;
        this.LineSeatSelectList.forEach((item) => {
          if (item.SeatNo == data.SeatNo) flag = true;
        });
        if (!flag) {
          this.LineSeatSelectList.push(data);
        } else {
          this.LineSeatSelectList = this.LineSeatSelectList.filter((item) => {
            return item.SeatNo != data.SeatNo;
          });
        }
      }
      // 选择的座位号
      this.LineSeatSelectListNo = [];
      this.LineSeatSelectList.forEach((item) => {
        this.LineSeatSelectListNo.push(item.SeatNo);
      });
      // 是否全选
      if (this.LineSeatSelectListNo.length == this.LineClassSeatList.length) {
        this.LineEditSeatAll = true;
      } else {
        this.LineEditSeatAll = false;
      }
    },
    //修改座位数弹窗关闭前
    onChangeSeatBeforeClose(action, done) {
      if (action === "confirm") {
        if (this.isClose) {
          done(false);
        } else {
          done();
        }
      } else {
        done();
      }
    },
    //确认修改座位数
    onChangeSeat() {
      if (this.editSeatCount < 1 || this.editSeatCount > 2000) {
        this.$toast("不允许输入小于1或大于2000的值");
        return;
      }
      let params = {
        ClassGID: this.GID,
        OldSeatCount: this.oldSeatCount,
        NewSeatCount: this.editSeatCount,
        ModifyGID: this.adminInfo.GID, //操作员GID
        ModifyCode: this.adminInfo.UserCode, //操作员代码
        ModifyName: this.adminInfo.UserName, //操作员名称
      };
      this.$http
        .post(this.$api.lineClassSeatMapModify, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            let data = {
              toastText: "修改座位数成功",
            };
            this.InitSeat(data);
          } else {
            this.editSeatCount = this.oldSeatCount;
          }
        });
    },
    //  关闭修改座位数弹窗
    closeChangeDialog() {
      this.showChangeSeatNumber = false;
      this.editSeatCount = this.oldSeatCount;
    },
    // 点击更改座位数
    clickEditSeatCount() {
      this.showChangeSeatNumber = true;
    },
    // 点击刷新
    clickEditSeatRefresh() {
      // 初始化
      this.InitSeat();
    },
    // 初始化座位数据
    InitSeat(data) {
      // 清空数据
      this.LineSeatSelectList = []; // 已选择的座位
      this.LineSeatSelectListNo = []; // 已选择的座位号
      this.LineEditSeatAll = false; // 全选

      // 获取本地数据
      let localData = JSON.parse(
        window.localStorage.getItem("LineEditSeatInfo")
      );
      this.GID = localData.GID;
      this.LineClassName = localData.LineClassName;
      this.ClassTime = localData.ClassTime;

      // 请求
      let params = { ClassGID: this.GID };
      this.$http
        .post(this.$api.getLineClassSeatMapQuery, this.$qs.stringify(params))
        .then((res) => {
          let tempArray = JSON.parse(JSON.stringify(res.data));
          // 添加背景颜色
          tempArray = tempArray.map((item) => {
            // 枚举数据
            this.$enum.seatStatus.forEach((i) => {
              if (item.SeatStatusFlag == i.status) {
                item = {
                  ...item,
                  bgColor: i.bgColor,
                };
              }
            });
            return item;
          });
          // 当前座位数量
          this.editSeatCount = tempArray.length;
          this.oldSeatCount = tempArray.length;
          // 座位状态统计tag
          let tagList = [];
          let tagNameList = [];
          tempArray.forEach((item) => {
            if (tagList.length == 0 && tagNameList.length == 0) {
              tagList.push({
                title: item.SeatStatusName,
                bgColor: item.bgColor,
                count: 1,
              });
              tagNameList.push(item.SeatStatusName);
            } else {
              if (tagNameList.includes(item.SeatStatusName)) {
                tagList.forEach((i) => {
                  if (i.title == item.SeatStatusName) {
                    i.count++;
                  }
                });
              } else {
                tagList.push({
                  title: item.SeatStatusName,
                  bgColor: item.bgColor,
                  count: 1,
                });
                tagNameList.push(item.SeatStatusName);
              }
            }
          });
          this.LineClassSeatTagList = tagList;
          this.LineClassSeatList = tempArray;

          // 提示
          if (data && data.toastText) {
            this.$toast(data.toastText);
          }
        })
        .catch((err) => {
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped lang="less">
.LineClassEditSeatChart {
  font-size: 0.38rem;

  .LineEditContent {
    height: calc(100vh - 45px);
    display: flex;
    flex-direction: column;

    .LineEditSeatSecondTitle {
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.3rem 0.5rem;
      font-size: 0.48rem;
      font-weight: 700;

      .titleTime {
        font-size: 0.46rem;
      }
    }

    .LineEditSeat {
      flex: 1;
      background-color: #f1f1f1;
      overflow-y: auto;

      .LineSeatTopButtonArea {
        display: flex;
        justify-content: center;
        padding: 0.2rem 0;

        .seatButton {
          width: 25%;
          border: 1px solid #818181;
          padding: 0.15rem 0;
          border-radius: 0.14rem;
          background-color: #fff;

          &:active {
            background-color: #f7f7f7;
          }

          &:nth-child(1) {
            margin-right: 0.4rem;
          }
        }
      }

      .LineEditSeatContent {
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
        padding-bottom: 0.1rem;

        .LineSeatItem {
          width: 18.8%;
          margin-bottom: 0.1rem;
          margin-left: 1%;
          padding: 0.2rem 0;
          background-color: #ddd;
          box-sizing: border-box;

          .LineSeatItemInd {
            margin-bottom: 0.1rem;
            font-size: 0.48rem;
            font-weight: 700;
          }
        }
      }
    }

    .LineEditSeatFooter {
      border-top: 1px solid #e5e5e6;
      padding: 0.2rem;

      .LineSeatTag {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0.15rem;

        p {
          margin-right: 0.3rem;
          margin-bottom: 0.1rem;
        }
      }

      .LineEditSeatFooterTotal {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;

        .LineEditSeatFooterTotalNumber {
          .number {
            font-weight: 700;
            font-size: 0.4rem;
          }
        }

        .LineEditSeatFooterAll {
          margin-right: 0.1rem;
        }
      }

      .LineEditSeatFooterButton {
        display: flex;
        justify-content: space-between;

        .footerButton {
          width: 32%;
          background-color: #fff;
          padding: 0.3rem 0;

          &:active {
            background-color: #f7f7f7;
          }
        }
      }
    }
  }
}</style>
